<div class="pagination-container">
    <!-- Entire row with two sections -->
    <div class="pagination-row">
        <!-- Left Section: Pagination Controls -->
        <div class="pagination-controls">
            <!-- Previous Button -->
            <button class="pagination-btn" (click)="goToPreviousPage()" [disabled]="currentPage === 1">
                <div class="icon-wrapper">
                    <img [src]="getPreviousArrow()" alt="Previous" />
                </div>
            </button>

            <!-- Page Numbers -->
            <div class="page-numbers">
                <span *ngFor="let page of visiblePages" (click)="goToPage(page)" [class.active]="page === currentPage">
                    {{ page }}
                </span>
            </div>

            <!-- Next Button -->
            <button class="pagination-btn" (click)="goToNextPage()" [disabled]="currentPage === getTotalPages()">
                <div class="icon-wrapper">
                    <img [src]="getNextArrow()" alt="Next" />
                </div>
            </button>
        </div>

        <!-- Right Section: Page Size Dropdown and Display Info -->
        <div class="pagination-info">
            <!-- Page Size Dropdown -->
            <select class="page-size-dropdown" [(ngModel)]="pageSize" (change)="updatePageSize()">
                <option *ngFor="let size of pageSizes" [value]="size">{{ size }}</option>
            </select>

            <!-- Display Information -->
            <div class="display-info">
                {{'PAGINATION.DISPLAYING' | translate}} {{ startRecord }} - {{ endRecord }} {{'PAGINATION.OF' |
                translate}} {{ totalRecords }}
                {{'PAGINATION.RECORDS' | translate}}
            </div>
        </div>
    </div>
</div>